<template>
    <div class="home-news">
        <div class="join-wrapper">
            <p class="title">{{ news.title }}</p>
            <p class="description" v-html="news.description"></p>
            <div class="join-social">
                <a v-for="social in socials" :key="social.nework" :href="social.url" target="_blank"
                    rel="noopener noreferrer">
                    <span class="icon" v-html="social.icon"></span>
                </a>
            </div>
        </div>
        <Button v-if="news.showMoreLink" variant="link" as-child><a :href="news.showMoreLink.url">{{
            news.showMoreLink.text }}</a></Button>
    </div>
</template>
<script setup lang="ts">
import { Button } from '@/components/ui/button';
import { IHomeNewsProps } from './HomeNews.model';
import { getIcon } from '@/components/Common/ShareNetwork/ShareNetwork.helper';


const { news } = defineProps<IHomeNewsProps>();

const socials = news.enabledSocialMedia.map(socialMedia => {
    const socialMediaName = socialMedia.text.toLowerCase();
    return ({ icon: getIcon(socialMediaName), nework: socialMediaName, url: socialMedia.value })
})


</script>
<style scoped lang="scss">
.home-news {
    display: flex;
    flex-direction: column;
    align-items: center;

    .join-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 18px 20px;

        .title {
            font-size: 2rem;
            line-height: 1;
            font-weight: 200;
        }

        .description {
            margin-top: 4px;
            width: fit-content;
        }

        .join-social {
            margin-top: 18px;
            display: flex;
            gap: 15px;

            .icon {
                :deep(svg) {
                    height: 45px;
                    fill: var(--primary);

                    &:hover {
                        fill: var(--primary-dark);
                    }
                }
            }
        }
    }
}
</style>